<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
    {{ dialogTitle() }}
  </div>
  <button mat-icon-button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>

  <form [formGroup]="chemForm" (ngSubmit)="saveChemistry()" class="form-grid">

    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Lab</mat-label>
        <mat-select formControlName="c_LabId">
          <mat-option *ngFor="let lab of labTypes()" [value]="lab.id">
            {{ lab.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="chemForm.get('c_LabId')?.errors?.['required']">
          Lab is required
        </mat-error>
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Testing Type</mat-label>
        <mat-select formControlName="testing_Type">
          <mat-option [value]="null">- Select Testing Type -</mat-option>
          <mat-option [value]="1">Permit</mat-option>
          <mat-option [value]="2">Internal</mat-option>
        </mat-select>
        <mat-error *ngIf="chemForm.get('testing_Type')?.errors?.['required']">
          Testing Type is required
        </mat-error>
      </mat-form-field>

      <!-- Sample ID an report -->
      <mat-form-field appearance="outline">
        <mat-label>Sample ID</mat-label>
        <input matInput type="text" formControlName="c_SampleID" placeholder="Enter Sample ID" maxlength="15">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Lab Report ID</mat-label>
        <input matInput type="text" formControlName="c_LabreportID" placeholder="Enter Lab Report ID" maxlength="15">
        <mat-error *ngIf="chemForm.get('c_LabreportID')?.errors?.['required']">
          Lab Report ID is required
        </mat-error>
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <!-- Sample & test Date -->
      <mat-form-field appearance="outline">
        <mat-label>Sample Date</mat-label>
        <input matInput [matDatepicker]="picker1" formControlName="c_DateSampled">
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Test Date</mat-label>
        <input matInput [matDatepicker]="picker2" formControlName="c_DateTested">
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <!-- cod and solids -->
      <mat-form-field appearance="outline">
        <mat-label>COD (mg/l)</mat-label>
        <input matInput type="text" formControlName="cod" placeholder="Enter COD"
          (input)="roundOff($event, 9999999, 4, 0, 'cod')" />
      </mat-form-field>
      <mat-form-field appearance="outline" [class.validation-field]="chemForm.get('tvs')?.invalid && (chemForm.get('tvs')?.dirty || chemForm.get('tvs')?.touched)">
        <mat-label>Total Volatile Solids (%)</mat-label>
        <input matInput type="text" formControlName="tvs" placeholder="Enter Total Volatile Solids"
          (input)="roundOff($event, 100, 4, 0, 'tvs')" />
          @if (chemForm.get('tvs')?.hasError('max')) {
            <mat-error>Value cannot be greater than 100</mat-error>
          }
      </mat-form-field>

      <!-- solids and chlorides -->
      <mat-form-field appearance="outline" [class.validation-field]="chemForm.get('ts')?.invalid && (chemForm.get('ts')?.dirty || chemForm.get('ts')?.touched)">
        <mat-label>Total Solids (%)</mat-label>
        <input matInput type="text" formControlName="ts" placeholder="Enter Total Solids"
          (input)="roundOff($event, 100, 4, 0, 'ts')" />
          @if (chemForm.get('ts')?.hasError('max')) {
            <mat-error>Value cannot be greater than 100</mat-error>
          }
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Chlorides (mg/L)</mat-label>
        <input matInput type="text" formControlName="chlorides" placeholder="Enter Chlorides"
          (input)="roundOff($event, 9999999, 4, 0, 'chlorides')" />
      </mat-form-field>

      <!-- gravity carbon -->
      <mat-form-field appearance="outline">
        <mat-label>Specific Gravity</mat-label>
        <input matInput type="text" formControlName="density" placeholder="Enter Specific Gravity"
          (input)="roundOff($event, 9999999, 4, 0, 'density')" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Total Organic Carbon (mg/l)</mat-label>
        <input matInput type="text" formControlName="totalCarbon" placeholder="Enter Total Organic Carbon"
          (input)="roundOff($event, 9999999, 4, 0, 'totalCarbon')" />
      </mat-form-field>

    </div>
    <div class="form-grid-row">
      <!-- ammonia and tkn -->
      <mat-form-field appearance="outline">
        <mat-label>Ammonia (mg/l)</mat-label>
        <input matInput type="text" formControlName="ammonia" placeholder="Enter Ammonia" maxlength="10" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>TKN (mg/l)</mat-label>
        <input matInput type="text" formControlName="tkn" placeholder="Enter TKN" maxlength="10" />
      </mat-form-field>

      <!-- total nitrogen and sulfur -->
      <mat-form-field appearance="outline">
        <mat-label>Total Nitrogen (mg/l)</mat-label>
        <input matInput type="text" formControlName="totalNitrogen" placeholder="Enter Total Nitrogen"
          (input)="roundOff($event, 9999999, 4, 0, 'totalNitrogen')" />
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Total Sulfur (mg/L)</mat-label>
        <input matInput type="text" formControlName="totalSulfur" placeholder="Enter Total Sulfur" maxlength="10" />
      </mat-form-field>

      <!-- Sulfides and phosphate -->
      <mat-form-field appearance="outline">
        <mat-label>Sulfides (mg/L)</mat-label>
        <input matInput type="text" formControlName="sulfides" placeholder="Enter Sulfides" maxlength="10" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Phosphorus (mg/L)</mat-label>
        <input matInput type="text" formControlName="phosphate" placeholder="Enter Phosphorus" maxlength="10" />
      </mat-form-field>

    </div>
    <div class="form-grid-row">
      <!-- potassium and pH -->
      <mat-form-field appearance="outline">
        <mat-label>Potassium (mg/l)</mat-label>
        <input matInput type="text" formControlName="potassium" placeholder="Enter Potassium" maxlength="10" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Ph</mat-label>
        <input matInput type="text" formControlName="pH" placeholder="Enter Ph"
          (input)="roundOff($event, 9.99, 2, 0, 'pH')" />
      </mat-form-field>

      <!-- sodium and calcium -->
      <mat-form-field appearance="outline">
        <mat-label>Sodium (mg/L)</mat-label>
        <input matInput type="text" formControlName="sodium" placeholder="Enter Sodium" maxlength="10" />
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Calcium (mg/L)</mat-label>
        <input matInput type="text" formControlName="calcium" placeholder="Enter Calcium" maxlength="10" />
      </mat-form-field>

      <!-- magnesium and iron -->
      <mat-form-field appearance="outline">
        <mat-label>Magnesium (mg/L)</mat-label>
        <input matInput type="text" formControlName="magnesium" placeholder="Enter Magnesium" maxlength="10" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Iron (mg/L)</mat-label>
        <input matInput type="text" formControlName="iron" placeholder="Enter Iron" maxlength="10" />
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <!-- methanol and oils and grease -->
      <mat-form-field appearance="outline">
        <mat-label>Methanol (mg/L)</mat-label>
        <input matInput type="text" formControlName="methanol" placeholder="Enter Methanol" maxlength="10" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Oils and Grease (mg/L)</mat-label>
        <input matInput type="text" formControlName="oilsAndGrease" placeholder="Enter Oils and Grease"
          maxlength="10" />
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline" class="large">
        <mat-label>Notes</mat-label>
        <textarea matInput rows="3" formControlName="notes" placeholder="Enter Notes" maxlength="3000"></textarea>
      </mat-form-field>
    </div>   
  </form>

</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-footer">
  <button mat-raised-button color="primary" type="button" (click)="close()"> Cancel</button>
  @if(canSave){
    <button mat-raised-button color="primary" type="button" (click)="saveChemistry()"> Save </button>
  }
</mat-dialog-actions>